import { supabase } from "@/integrations/supabase/client";

export interface CreateInviteParams {
  workspaceId: string;
  email: string;
  role: 'admin' | 'member';
  createdBy: string;
}

export async function createInvite({ workspaceId, email, role, createdBy }: CreateInviteParams) {
  const { data, error } = await supabase
    .from('workspace_invites')
    .insert({
      workspace_id: workspaceId,
      email,
      role,
      created_by: createdBy,
    })
    .select()
    .single();

  if (error) throw error;
  return data;
}

export async function getInviteByToken(token: string) {
  const { data, error } = await supabase
    .from('workspace_invites')
    .select(`
      id,
      workspace_id,
      email,
      role,
      expires_at,
      accepted_at,
      workspaces (
        id,
        name,
        slug
      )
    `)
    .eq('token', token)
    .single();

  if (error) throw error;
  return data;
}

// Prüft, ob bereits eine aktive Einladung für diese E-Mail im Workspace existiert
export async function checkDuplicateInvite(workspaceId: string, email: string): Promise<boolean> {
  const { data, error } = await supabase
    .from('workspace_invites')
    .select('id')
    .eq('workspace_id', workspaceId)
    .eq('email', email.toLowerCase().trim())
    .is('accepted_at', null)
    .gt('expires_at', new Date().toISOString())
    .limit(1);

  if (error) {
    console.error('Error checking duplicate invite:', error);
    return false;
  }

  return (data?.length ?? 0) > 0;
}

// Prüft, ob ein User bereits Mitglied des Workspace ist
export async function checkExistingMember(workspaceId: string, email: string): Promise<boolean> {
  const { data, error } = await supabase
    .from('workspace_members')
    .select(`
      id,
      seat_status,
      profiles!inner (email)
    `)
    .eq('workspace_id', workspaceId)
    .eq('profiles.email', email.toLowerCase().trim())
    .eq('seat_status', 'active')
    .limit(1);

  if (error) {
    console.error('Error checking existing member:', error);
    return false;
  }

  return (data?.length ?? 0) > 0;
}
